module.exports = __webpack_public_path__ + "img/prop-bush-3.6c579edf.png";